<span class="tooltiptext" [ngStyle]="positionStyle">{{ text }}</span>
